exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.line[data-v-0ddd17a4] {\n  height: 1px;\n  margin: 0px 0px 20px 0px;\n  background-color: #eaeaea;\n}\n.form-item[data-v-0ddd17a4] {\n  margin: 10px;\n  padding: 10px;\n  border: 1px solid #eeeeee;\n  border-radius: 10px;\n  color: #606266;\n}\n.form-item span[data-v-0ddd17a4] {\n  font-weight: bold;\n}\n", ""]);

// exports
